module.exports = __webpack_public_path__ + "img/qr-icon.9899b381.png";